const typeGuardName = <T extends object>(
  item: T,
  nameKey: PropertyKey
): nameKey is keyof T => nameKey in item;

// display_name , long_name, name のいづれかには引っかかるはず
const names = ['display_name', 'long_name', 'name'];
const getName = <T extends object>(item: T, key: string) =>
  // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
  typeGuardName(item, key) ? (item[key] as string | undefined) : '';
export const findByName = <T extends object>(items: T[], value: string) => {
  // 完全一致で検索
  const item = items.find((item) => {
    const v = names.some((key) => getName(item, key) === value);
    return v;
  });
  if (item) return item;
  // 部分一致で検索
  return items.find((item) => {
    const v = ['display_name', 'long_name', 'name'].some(
      (key) => getName(item, key)?.indexOf(value) !== -1
    );
    return v;
  });
};
